"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statsArrayToObj = exports.statsObjToArray = exports.kindLongFormat = exports.kindShortFormat = exports.isEquivalentStat = exports.isEquivalentRoundTripTime = exports.isEquivalentPacketLoss = exports.BANDWIDTH_UTILIZATION_PERCENTAGE_THRESHOLD = exports.ROUND_TRIP_TIME_THRESHOLD = exports.VIDEO_PACKET_LOSS_PERCENTAGE_THRESHOLD = exports.AUDIO_PACKET_LOSS_PERCENTAGE_THRESHOLD = void 0;
exports.AUDIO_PACKET_LOSS_PERCENTAGE_THRESHOLD = 20;
exports.VIDEO_PACKET_LOSS_PERCENTAGE_THRESHOLD = 10;
exports.ROUND_TRIP_TIME_THRESHOLD = 250;
exports.BANDWIDTH_UTILIZATION_PERCENTAGE_THRESHOLD = 90;
const isEquivalentPacketLoss = (kind, now, prev) => {
    const threshold = kind === "audio" || kind === "sound"
        ? exports.AUDIO_PACKET_LOSS_PERCENTAGE_THRESHOLD
        : exports.VIDEO_PACKET_LOSS_PERCENTAGE_THRESHOLD;
    return Math.max(now, prev) < threshold || Math.min(now, prev) > threshold;
};
exports.isEquivalentPacketLoss = isEquivalentPacketLoss;
const isEquivalentRoundTripTime = (_kind, now, prev) => Math.max(now, prev) < exports.ROUND_TRIP_TIME_THRESHOLD ||
    Math.min(now, prev) > exports.ROUND_TRIP_TIME_THRESHOLD;
exports.isEquivalentRoundTripTime = isEquivalentRoundTripTime;
const isEquivalentStat = (kind, now, prev) => now.score === prev.score &&
    (0, exports.isEquivalentPacketLoss)(kind, now.fractionLost, prev.fractionLost) &&
    (0, exports.isEquivalentRoundTripTime)(kind, now.roundTripTime, prev.roundTripTime);
exports.isEquivalentStat = isEquivalentStat;
const kindShortFormat = (kind) => {
    if (kind === "audio") {
        return "a";
    }
    else if (kind === "video") {
        return "v";
    }
    else if (kind === "screen") {
        return "s";
    }
    else if (kind === "sound") {
        return "d";
    }
    else {
        return "v";
    }
};
exports.kindShortFormat = kindShortFormat;
const kindLongFormat = (kind) => {
    if (kind === "a") {
        return "audio";
    }
    else if (kind === "v") {
        return "video";
    }
    else if (kind === "s") {
        return "screen";
    }
    else if (kind === "d") {
        return "sound";
    }
    else {
        return "video";
    }
};
exports.kindLongFormat = kindLongFormat;
const statsObjToArray = (stats) => [
    stats.score,
    stats.fractionLost,
    stats.roundTripTime,
    stats.bitrate,
    stats.jitter ?? 0,
];
exports.statsObjToArray = statsObjToArray;
const statsArrayToObj = (stats) => ({
    ssrc: 0,
    score: stats[0] ?? 10,
    fractionLost: stats[1] ?? 0,
    roundTripTime: stats[2] ?? 0,
    bitrate: stats[3] ?? 0,
    jitter: stats[4] ?? 0,
});
exports.statsArrayToObj = statsArrayToObj;
//# sourceMappingURL=serverStats.js.map